import { render, staticRenderFns } from "./TargetCampaigns.vue?vue&type=template&id=44c18ba2&scoped=true"
import script from "./TargetCampaigns.vue?vue&type=script&lang=js"
export * from "./TargetCampaigns.vue?vue&type=script&lang=js"
import style0 from "./TargetCampaigns.vue?vue&type=style&index=0&id=44c18ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c18ba2",
  null
  
)

export default component.exports